/* MAISON ROTEA PDP DRAWERS V2 */
(() => {
  if (window.RoteaPDPDrawersV2) return;
  window.RoteaPDPDrawersV2 = true;

  let overlay = null;
  let panel = null;
  let scroll = null;
  let heading = null;
  let closeButton = null;
  let activeSummary = null;
  let previousFocus = null;
  let previousOverflow = "";

  const validBlocks = [
    "overview",
    "technical",
    "dimensions"
  ];

  function build() {
    if (overlay) return;

    overlay = document.createElement("div");
    overlay.className = "rotea-pdp-drawer-backdrop";
    overlay.setAttribute("aria-hidden", "true");

    overlay.innerHTML = `
      <div class="rotea-pdp-drawer"
           role="dialog"
           aria-modal="true"
           aria-labelledby="rotea-pdp-drawer-title"
           tabindex="-1">
        <div class="rotea-pdp-drawer__header">
          <h2 class="rotea-pdp-drawer__title"
              id="rotea-pdp-drawer-title"></h2>
          <button type="button"
                  class="rotea-pdp-drawer__close"
                  aria-label="Fermer le panneau">
            <svg viewBox="0 0 24 24"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="1.5"
                 aria-hidden="true">
              <path d="M5 5l14 14M19 5L5 19"/>
            </svg>
          </button>
        </div>
        <div class="rotea-pdp-drawer__scroll"></div>
      </div>
    `;

    document.body.appendChild(overlay);

    panel = overlay.querySelector(
      ".rotea-pdp-drawer"
    );

    scroll = overlay.querySelector(
      ".rotea-pdp-drawer__scroll"
    );

    heading = overlay.querySelector(
      ".rotea-pdp-drawer__title"
    );

    closeButton = overlay.querySelector(
      ".rotea-pdp-drawer__close"
    );

    closeButton.addEventListener("click", close);

    overlay.addEventListener("click", event => {
      if (event.target === overlay) close();
    });
  }

  function prepareContent(source) {
    const wrapper = document.createElement("div");
    wrapper.className = "rotea-pdp-drawer-content rte";

    // Copier le contenu Shopify plutôt que déplacer
    // l'élément natif de l'accordéon.
    Array.from(source.childNodes).forEach(node => {
      wrapper.appendChild(node.cloneNode(true));
    });

    // Conserver le tableau technique déjà généré.
    // Si son script n'a pas produit de lignes,
    // afficher le contenu fournisseur original.
    const techTable = wrapper.querySelector(
      ".rotea-tech-table"
    );

    const techSource = wrapper.querySelector(
      ".rotea-tech-source"
    );

    if (techTable && techSource) {
      const hasRows = (
        techTable.children.length > 0 &&
        techTable.textContent.trim().length > 0
      );

      if (hasRows) {
        wrapper.classList.add(
          "rotea-pdp-drawer-has-tech-table"
        );
      } else {
        techTable.remove();
      }
    }

    // Retirer les identifiants dupliqués de la copie.
    wrapper.querySelectorAll("[id]").forEach(el => {
      el.removeAttribute("id");
    });

    return wrapper;
  }

  function open(details, summary) {
    if (activeSummary) close();

    build();

    const source = details.querySelector(
      ".accordion__content"
    );

    if (!source) return;

    previousFocus = document.activeElement;

    const title = summary.querySelector(
      ".accordion__title"
    );

    heading.textContent = title
      ? title.textContent.trim()
      : summary.textContent.trim();

    scroll.replaceChildren(
      prepareContent(source)
    );

    scroll.scrollTop = 0;

    activeSummary = summary;
    previousOverflow = document.body.style.overflow;

    document.body.classList.add(
      "rotea-pdp-drawer-open"
    );

    document.body.style.overflow = "hidden";

    overlay.removeAttribute("inert");
    overlay.setAttribute("aria-hidden", "false");
    overlay.classList.add("is-open");

    summary.setAttribute("aria-expanded", "true");

    closeButton.focus();
  }

  function close() {
    if (!activeSummary) return;

    const summary = activeSummary;
    activeSummary = null;

    overlay.classList.remove("is-open");

    document.body.classList.remove(
      "rotea-pdp-drawer-open"
    );

    document.body.style.overflow = previousOverflow;

    summary.setAttribute("aria-expanded", "false");

    const target = summary.isConnected
      ? summary
      : previousFocus;

    // Fermer proprement avant de restituer le focus.
    if (target && target.isConnected) {
      target.focus();
    }

    overlay.setAttribute("aria-hidden", "true");
    overlay.setAttribute("inert", "");
    scroll.replaceChildren();
  }

  document.addEventListener("keydown", event => {
    if (!activeSummary) return;

    if (event.key === "Escape") {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== "Tab") return;

    const elements = Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), ' +
        'input:not([disabled]), ' +
        'select:not([disabled]), ' +
        'textarea:not([disabled]), ' +
        '[tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => (
      el.getClientRects().length &&
      getComputedStyle(el).visibility !== "hidden"
    ));

    if (!elements.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const first = elements[0];
    const last = elements[elements.length - 1];

    if (event.shiftKey) {
      if (
        document.activeElement === first ||
        document.activeElement === panel
      ) {
        event.preventDefault();
        last.focus();
      }
    } else if (
      document.activeElement === last ||
      !panel.contains(document.activeElement)
    ) {
      event.preventDefault();
      first.focus();
    }
  });

  function init(root = document) {
    const accordions = root.querySelectorAll(
      ".product__accordion > details"
    );

    accordions.forEach(details => {
      const isTarget = validBlocks.some(
        key => details.id.startsWith(
          "Details-" + key + "-"
        )
      );

      if (!isTarget) return;
      if (details.dataset.roteaDrawerReady) return;

      const summary = details.querySelector("summary");
      const content = details.querySelector(
        ".accordion__content"
      );

      if (!summary || !content) return;

      details.dataset.roteaDrawerReady = "true";

      const container = details.closest(
        ".product__accordion"
      );

      if (container) {
        container.classList.add(
          "rotea-drawer-enabled"
        );
      }

      summary.setAttribute(
        "aria-haspopup",
        "dialog"
      );

      summary.setAttribute(
        "aria-expanded",
        "false"
      );

      summary.addEventListener("click", event => {
        event.preventDefault();
        open(details, summary);
      });
    });
  }

  function start() {
    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start
    );
  } else {
    start();
  }

  document.addEventListener(
    "shopify:section:load",
    event => init(event.target)
  );

  document.addEventListener(
    "shopify:section:unload",
    () => {
      if (activeSummary) close();
    }
  );
})();
